// extracted by mini-css-extract-plugin
export default {"customToast":"CustomToast_customToast__qBEEE","customToastBody":"CustomToast_customToastBody__iUPbn"};